document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll('[data-id="element-54"]');
  const target = document.querySelector('[data-id="element-58"]');

  if (!buttons.length || !target) return;

  buttons.forEach(btn => {
    btn.addEventListener("click", () => {
      const offset = 0;
      const top = target.offsetTop - offset;

      window.scrollTo({
        top,
        behavior: "smooth"
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {

  const floating = document.querySelector('[data-id="element-98"]');
  if (!floating) return;

  const showAfter = 800;

  window.addEventListener("scroll", () => {
    if (window.scrollY > showAfter) {
      floating.style.bottom = "1rem"; // ✅ show
    } else {
      floating.style.bottom = "-100%"; // ❌ hide
    }
  });

});

document.addEventListener("DOMContentLoaded", () => {
    const button = document.querySelector('[data-id="element-56"]');
    const target = document.querySelector('[data-id="element-148"]');

    button.addEventListener("click", () => {
        const offset = 100; // adjust header height
        const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({
            top: top,
            behavior: "smooth"
        });
    });
});

document.addEventListener("DOMContentLoaded", () => {
  const section = document.querySelector('[data-id="element-122"]');
  if (!section) return;

  const timeElements = section.querySelectorAll('[data-id="element-146"]');
  if (timeElements.length < 3) return;

  const STORAGE_KEY = "countdown_end_time";

  // ✅ Fixed target date (IST safe)
  const FIXED_END_TIME = new Date("2026-03-28T23:59:59+05:30").getTime();

  let endTime = localStorage.getItem(STORAGE_KEY);

  // If not set → store fixed date
  if (!endTime) {
    endTime = FIXED_END_TIME;
    localStorage.setItem(STORAGE_KEY, endTime);
  } else {
    endTime = parseInt(endTime);
  }

  function updateTimer() {
    const now = new Date().getTime();
    const distance = endTime - now;

    if (distance <= 0) {
      timeElements[0].textContent = "00";
      timeElements[1].textContent = "00";
      timeElements[2].textContent = "00";

      clearInterval(timerInterval);
      return;
    }

    // ⚠️ Total hours (not %24 because no days UI)
    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    timeElements[0].textContent = String(hours).padStart(2, '0');
    timeElements[1].textContent = String(minutes).padStart(2, '0');
    timeElements[2].textContent = String(seconds).padStart(2, '0');
  }

  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
});

document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll('[data-id="element-72"]').forEach(card => {

    const buttons = card.querySelectorAll('[data-id="element-88"]');
    const select = card.querySelector('select[name="id"]');
    const salePrice = card.querySelector('[data-id="element-91"]');
    const comparePrice = card.querySelector('[data-id="element-92"]');

    if (!buttons.length || !select) return;

    // Create variant map from select
    const variants = Array.from(select.options).map(option => {
      return {
        id: option.value,
        title: option.textContent.trim(),
        price: option.getAttribute('data-price'),
        compare: option.getAttribute('data-compare-price')
      };
    });

    buttons.forEach((btn, index) => {
      btn.addEventListener("click", () => {

        // Remove active from all
        buttons.forEach(b => {
          b.classList.remove('border-berry-red','bg-berry-red/5','text-berry-red');
          b.classList.add('border-gray-200','text-gray-600');
        });

        // Add active
        btn.classList.add('border-berry-red','bg-berry-red/5','text-berry-red');
        btn.classList.remove('border-gray-200','text-gray-600');

        // Match variant by index
        const variant = variants[index];
        if (!variant) return;

        // Update select value
        select.value = variant.id;
        select.dispatchEvent(new Event('change'));

        // OPTIONAL: If you add data attributes in Shopify
        if (variant.price && salePrice) {
          salePrice.textContent = variant.price;
        }

        if (variant.compare && comparePrice) {
          comparePrice.textContent = variant.compare;
        }

      });
    });

  });

});